import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  33% {
    transform: translateY(-15px) rotate(120deg);
  }
  66% {
    transform: translateY(8px) rotate(240deg);
  }
`;

export const LayoutContainer = styled.div`
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  overflow-x: hidden;
`;

export const FloatingElement = styled.div`
  position: absolute;
  width: 80px;
  height: 80px;
  background: linear-gradient(45deg, rgba(43, 56, 87, 0.1), rgba(197, 51, 123, 0.05));
  border-radius: 50%;
  animation: ${float} 20s ease-in-out infinite;
  animation-delay: ${props => props.delay};
  z-index: 1;
  
  &:nth-child(2) {
    top: 20%;
    right: 10%;
    width: 60px;
    height: 60px;
  }
  
  &:nth-child(3) {
    top: 60%;
    left: 5%;
    width: 100px;
    height: 100px;
  }
  
  &:nth-child(4) {
    bottom: 20%;
    right: 20%;
    width: 70px;
    height: 70px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #2B3857 0%, #1a2332 100%);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(197, 51, 123, 0.2);
  padding: 1rem 2rem;
  z-index: 100;
  transition: all 0.3s ease;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  transition: margin-left 0.3s ease;

  /* Dynamic margin based on sidebar state */
  margin-left: ${props => props.sidebarOpen ? '280px' : '0'};

  /* No sidebar offset on mobile and medium screens */
  @media (max-width: 1024px) {
    margin-left: 0;
  }
`;

export const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(43, 56, 87, 0.2);
  }
`;

export const Logo = styled.h1`
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`;

export const UserName = styled.span`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    display: none;
  }
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #C5337B, #E91E63);
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(197, 51, 123, 0.4);
    
    &:before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
`;

export const MainContent = styled.main`
  margin-top: 80px;
  padding: 2rem;
  position: relative;
  z-index: 5;
  min-height: calc(100vh - 80px);
  transition: margin-left 0.3s ease;

  /* Dynamic margin based on sidebar state and screen size */
  margin-left: ${props => props.sidebarOpen ? '280px' : '0'};

  /* No sidebar offset on mobile and medium screens regardless of state */
  @media (max-width: 1024px) {
    margin-left: 0;
    padding: 1rem;
  }

  /* Responsive padding for large screens */
  @media (min-width: 1025px) {
    padding: 2rem;
  }
`;
